import type { ReactNode } from "react";
import { AppPageLayout } from "./AppPageLayout";
import Title from "./Title";

interface AppHubPageProps {
    title: string;
    description: string;
    children: ReactNode;
}

export function AppHubPage({ title, description, children }: AppHubPageProps) {
    return (
        <AppPageLayout width="full" padding="lg" className="flex flex-col gap-6">
            <Title words={title} description={description} />
            <div className="gap-6 grid grid-cols-1 lg:grid-cols-3">{children}</div>
        </AppPageLayout>
    );
}
